import { ITableButtonTypes } from '../../components/Table/types/tableFooterButtonsTypes';
import { INoticePageIdTypes } from '../../modules/notification/types/noticePageIdTypes';
import { EUserType } from '../PageAuth/constants/authConstants';

export interface ISubscriberIdQuery {
    subscriberId: string;
}

export interface ISubscriberIdMetaQuery extends ISubscriberIdQuery {
    userType: EUserType;
}

export interface ISubscriberIdMeta extends INoticePageIdTypes {
    account: {
        id: number;
        // не является ссылкой для пользователя с абонентским УД
        isLink: boolean;
        number: string;
    };
    accessPoints?: Array<{
        apn: string;
        ip?: string;
    }>;
    // Кнопки для футера
    buttons?: ITableButtonTypes[];
    name: string;
    number: string; // телефон приходит уже с примененной маской? (+ 7 (999) ...)
    region: string;
    regionId: number;
    servicesCategoryId: number;
    userType?: number;
    currCountryName?: string;
    eventTimeChangeCountry?: string;
}

export type TSubscriberIdButtonsEnabled = { [buttonName: string]: boolean };

export interface ISubscriberIdStatus {
    date?: string;
    description?: string;
    hintCode?: string;
    id: number;
    isBlocked?: boolean;
    isBtnLocked?: boolean;
    lockDate?: string;
    name: string;
}

export enum ESubscriberIdActions {
    // info
    lock = 'LOCK',
    tariffChange = 'TARIFF_CHANGE',
    // product
    productDisconnect = 'PRODUCT_DISCONNECT',
    // personal data
    personalDataEdit = 'PERSONAL_DATA_EDIT',
    personalDataConfirm = 'PERSONAL_DATA_CONFIRM',
    personalDataDelete = 'PERSONAL_DATA_DELETE',
    // additional-accounts
    accountChange = 'ACCOUNT_CHANGE',
    // Manage number
    forwardingChange = 'FORWARDING_CHANGE',
    forwardingShow = 'FORWARDING_SHOW',
    labelShow = 'LABEL_SHOW',
    positionChange = 'POSITION_CHANGE',
    positionShow = 'POSITION_SHOW',
    simCardChange = 'SIM_CARD_CHANGE',
    simCardSuggest = 'SIM_CARD_SUGGEST',
}
